module.exports = __webpack_public_path__ + "img/logo.bd669215.svg";